import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, Col, Row, Spinner } from "reactstrap";
import profileImg from "../../assets/images/profile-img.png";
import avatar from "../../assets/images/users/avatar-default.png";
const WelcomeComp = ({ totalMessage, tenant, style }) => {
  const Profile = useSelector(state => state.Profile);
  const { userInfo, avatar_id, avatarImg, loading } = Profile;
  return (
    <React.Fragment>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner color="primary" />
        </div>
      ) : (
        <Card className="overflow-hidden">
          <div className="bg-primary bg-soft">
            <Row>
              <Col xs="7">
                <div className="text-primary p-3">
                  <h5 className="text-primary">Welcome Back !</h5>
                  <h5>4Si E-Invoice</h5>
                </div>
              </Col>
              <Col xs="5" className="align-self-end">
                <img src={profileImg} alt="" className="img-fluid" />
              </Col>
            </Row>
          </div>
          <CardBody className="pt-0">
            <Row>
              <Col sm="4">
                <div className="avatar-md profile-user-wid mb-4">
                  <img
                    src={avatarImg ? avatarImg : avatar}
                    alt=""
                    className="img-thumbnail rounded-circle"
                  />
                </div>
                <h5 className="font-size-15 text-truncate">
                  {userInfo?.display_name}
                </h5>
                <p className="text-muted mb-0 text-truncate">
                  {userInfo?.username}
                </p>
              </Col>

              <Col sm="8">
                <div className="pt-4">
                  <Row>
                    <Col xs="6">
                      <h4 className=" d-flex align-items-center">
                        <i className="bx bx-receipt text-primary"></i>
                        {totalMessage && totalMessage.total_invoice}
                      </h4>
                      <h6 className="mb-0 text-primary">Tổng số hóa đơn</h6>
                    </Col>
                    {/* <Col xs="6">
                      <h2 className=" d-flex align-items-center">
                        <i className="bx bx-bell text-warning"></i>
                      </h2>
                      <h4 className="mb-0 text-warning">Tổng số thông báo</h4>
                    </Col> */}
                  </Row>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
    </React.Fragment>
  );
};
WelcomeComp.propTypes = {
  totalMessage: PropTypes.any,
  tenant: PropTypes.any,
  style: PropTypes.any,
};
export default WelcomeComp;
